import NewsDetailLayout from '../NewsDetailLayout';
import { rinechanData } from '../newsDetailData';

const RinechanDetail = () => <NewsDetailLayout data={rinechanData} />;
export default RinechanDetail;
